import { FunctionComponent, ReactElement } from 'react';
import { Backdrop as MuiBackdrop, CircularProgress } from '@mui/material';

interface BackdropProps {
	sx?: Record<string, unknown>;
}

const Backdrop: FunctionComponent<BackdropProps> = ({ sx }): ReactElement => (
	<MuiBackdrop sx={{ zIndex: (theme) => theme.zIndex.appBar - 1, ...sx }} open={true}>
		<CircularProgress color="inherit" />
	</MuiBackdrop>
);

export default Backdrop;
